// Copyright (c) 2026. Hardfin, Inc. All rights reserved.
// Hardfin Confidential - Restricted
import { StatusChipProps } from '@/components/status-chip';

/**
 * Display status for shipments, derived from timestamp fields.
 * Priority: cancelled > received > delivered > shipped > pending
 */
type ShipmentStatus =
  | 'open'
  | 'shipped'
  | 'delivered'
  | 'received'
  | 'cancelled';

/**
 * Chip styling for each shipment status.
 * Colors match POLineItemStatus colors for consistency.
 */
export const SHIPMENT_STATUS_CONFIG: Record<ShipmentStatus, StatusChipProps> = {
  open: { variant: 'filled', color: 'default', label: 'Open' },
  shipped: { variant: 'filled', color: 'info', label: 'Shipped' },
  delivered: { variant: 'filled', color: 'primary', label: 'Delivered' },
  received: { variant: 'filled', color: 'success', label: 'Received' },
  cancelled: { variant: 'outlined', color: 'error', label: 'Cancelled' },
};

/**
 * Returns the chip props for a given shipment status.
 */
export function getShipmentStatusChipProps(
  status: ShipmentStatus
): StatusChipProps {
  return SHIPMENT_STATUS_CONFIG[status];
}
